import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import type { RecordModificationResponse } from "#root/utility/remote-data";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { holidayCollection, type HolidayListItem } from "#root/schema/platform/reference-data";
import PageLayout from "./layout";

export default function ({ holidayId }): ReactNode {
  const navigate = useNavigate();
  const handleUpdate = useCallback(
    (data: RecordModificationResponse<HolidayListItem>) => {
      if ("deleted" in data) {
        navigate("/admin/platform/reference/holiday");
      } else if ("created" in data) {
        navigate(`/admin/platform/reference/holiday/${data.created}`);
      }
    },
    [navigate],
  );

  return (
    <PageLayout title="Reference Data Platform - Edit Holiday">
      <section>
        <h2>{holidayId === "new" ? "Create" : "Edit"} Holiday</h2>
        <StandardEditor id={holidayId} collection={holidayCollection} onSave={handleUpdate} onDelete={handleUpdate}>
          <Fields.Set name="id">
            <label>Holiday Id</label>
            <Fields.Integer required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="holidayGroup">
            <label>Holiday Group</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="holidayName">
            <label>Holiday Name</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="holidayDate">
            <label>Holiday Date</label>
            <Fields.DateField required/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
